const currentfarmats={
    splitCurrent(v){
        let int = (v.split('.'))[0];
        let dec = '.'+(v.split('.'))[1];
        return [int,dec]
    },
    AUformat(v){
        let formatter = new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
        });
        let format_value = formatter.format(v);
        return format_value
    }
}

export default currentfarmats;